export const reservationTypes = {
  hotel: "ホテル",
  flight: "航空",
  dynamicPackage: "DP",
};
